
    import './styles.scoped.css';
    export default {
  "visible-content": "awsui_visible-content_tc96w_1b1c1_185",
  "visible-content-toggle": "awsui_visible-content-toggle_tc96w_1b1c1_186",
  "visible-content-groups": "awsui_visible-content-groups_tc96w_1b1c1_187",
  "visible-content-group": "awsui_visible-content-group_tc96w_1b1c1_187",
  "visible-content-title": "awsui_visible-content-title_tc96w_1b1c1_192",
  "visible-content-group-label": "awsui_visible-content-group-label_tc96w_1b1c1_200",
  "visible-content-option": "awsui_visible-content-option_tc96w_1b1c1_206",
  "visible-content-option-label": "awsui_visible-content-option-label_tc96w_1b1c1_217",
  "root": "awsui_root_tc96w_1b1c1_224",
  "modal-root": "awsui_modal-root_tc96w_1b1c1_225",
  "trigger-button": "awsui_trigger-button_tc96w_1b1c1_226",
  "cancel-button": "awsui_cancel-button_tc96w_1b1c1_227",
  "confirm-button": "awsui_confirm-button_tc96w_1b1c1_228",
  "custom": "awsui_custom_tc96w_1b1c1_229",
  "second-column-small": "awsui_second-column-small_tc96w_1b1c1_233",
  "wrap-lines": "awsui_wrap-lines_tc96w_1b1c1_237",
  "striped-rows": "awsui_striped-rows_tc96w_1b1c1_238",
  "page-size": "awsui_page-size_tc96w_1b1c1_239",
  "page-size-form-field": "awsui_page-size-form-field_tc96w_1b1c1_240",
  "page-size-radio-group": "awsui_page-size-radio-group_tc96w_1b1c1_241"
};
  